import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../http-client/http-client.service";

import { JurisdictionConfigService } from "./jurisdiction.config";
import { Jurisdiction } from "./jurisdiction.model";

@Injectable({
	providedIn: "root",
})
export class JurisdictionService {
	private countryMapping: Record<string, Jurisdiction>;
	private defaultJurisdiction: Jurisdiction;

	constructor(
		private config: JurisdictionConfigService,
		private httpClient: CoreHttpClient
	) {
		this.countryMapping = config.getCountryMapping();
		this.defaultJurisdiction = config.getDefaultJurisdiction();
	}

	getJurisdictionByCountryCode(countryCode: string | undefined): Jurisdiction {
		if (!countryCode) {
			return this.defaultJurisdiction;
		}

		return this.countryMapping[countryCode] || this.defaultJurisdiction;
	}

	transformCountryCode(countryCode: string, fallbackCountryCode: string): string {
		return countryCode.toLowerCase() === "se" ? fallbackCountryCode : countryCode;
	}

	getJurisdiction(): Observable<{ jurisdiction: Jurisdiction }> {
		return this.httpClient.get<{ jurisdiction: Jurisdiction }>({ url: this.config.getJurisdictionEndpoint() });
	}
}
